import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';

// Template data queried should match the data checked in getTemplateHasContent (modules/campaigns/editor/components/utils)
const queryTemplateAndContentById = gql`
  query getTemplateAndContent($id: Long!, $locale: TemplateLocaleInput) {
    templateAndSingleContent(id: $id, locale: $locale) {
      ... on TemplateAndContent {
        primaryContent {
          ... on EmailContentDefinition {
            subject
            html
            beeBuilderMetadata
          }
          ... on InAppContentDefinition {
            html
            beeBuilderMetadata
            messageFormat
          }
          ... on PushContentDefinition {
            message
            isSilentPush
          }
          ... on SMSContentDefinition {
            message
            verifiedContactCardId
          }
          ... on WebPushContentDefinition {
            message
            title
          }
          ... on EmbeddedContentDefinition {
            body
            title
            payload
            elements {
              mediaUrl
              buttons {
                __typename
              }
              text {
                __typename
              }
            }
          }
          ... on WhatsAppContentDefinition {
            message
            header {
              __typename
            }
            buttons {
              __typename
            }
            footer
          }
        }
      }
    }
  }
`;

export const useGetTemplateData = (templateId?: number) => {
  const { data, isLoading } = useGraphql(queryTemplateAndContentById, {
    variables: { id: templateId },
    skip: !templateId,
  });
  return {
    templateData: data?.templateAndSingleContent?.primaryContent,
    isLoading,
  };
};
